<template>
	<div style="padding-left:30px">
		<h3 style="text-align:left;margin-top:10px">工人相关</h3>
		<table  border="1px" style="width:600px;height:160px">
			<tr>
				<th></th><th>在场</th><th>离场</th><th>全部</th>
			</tr>
			<tr>
				<td>点工</td><td>{{diangonginfo.peoplenum0}}人</td><td>{{diangonginfo.peoplenum1}}人</td><td>{{diangonginfo.peoplenum}}人</td>
			</tr>
			<tr>
				<td>包工</td><td>{{baogonginfo.peoplenum0}}人</td><td>{{baogonginfo.peoplenum1}}人</td><td>{{baogonginfo.peoplenum}}人</td>
			</tr>
			<tr>
				<td>全部</td>
				<td>{{ parseInt(diangonginfo.peoplenum0)+parseInt(baogonginfo.peoplenum0) }} 人</td>
				<td>{{ parseInt(diangonginfo.peoplenum1)+parseInt(baogonginfo.peoplenum1) }} 人</td>
				<td>{{ parseInt(diangonginfo.peoplenum)+parseInt(baogonginfo.peoplenum) }} 人</td>
			</tr>
		</table>

		<!-- <h3 style="text-align:left;margin-top:30px">用工天数</h3>
		<table  border="1px" style="width:450px;height:80px">
			<tr>
				<th>点工</th><th>包工</th><th>全部</th>
			</tr>
			<tr>
				<td>点工</td><td></td><td></td>
			</tr>
		</table> -->
		<h3 style="text-align:left;margin-top:30px">工资</h3>
		<table  border="1px" style="width:900px;height:200px">
			<tr>
				<th></th><th>全部</th><th>点工</th><th>带班</th><th>班组</th><th>说明</th>
			</tr>
			<tr>
				<td>应发</td><td>{{(parseFloat(moneydiangong.yingfa)+parseFloat(moneydaiban.yingfa)+parseFloat(moneybanzu.yingfu)).toFixed(2) }}</td>
				<td>{{moneydiangong.yingfa.toFixed(2)}}</td>
				<td>{{moneydaiban.yingfa.toFixed(2)}}</td>
				<td>{{moneybanzu.yingfu.toFixed(2)}}</td><td></td>
			</tr>
			<tr>
				<td>预支</td>
				<td>{{(parseFloat(moneydiangong.yuzhi)+parseFloat(moneydaiban.yuzhi)+parseFloat(moneybanzu.yuzhi)).toFixed(2) }}</td>
				<td>{{moneydiangong.yuzhi.toFixed(2)}}</td>
				<td>{{moneydaiban.yuzhi.toFixed(2)}}</td>
				<td>{{moneybanzu.yuzhi.toFixed(2)}}</td><td></td>
			</tr>
			<tr>
				<td>项目发放</td>
				<td>{{fafang["sum"]}}</td>
				<td>{{fafang["diangong"]}}</td>
				<td>{{fafang["daiban"]}}</td>
				<td>{{fafang["banzu"]}}</td><td></td>
			</tr>
			<tr>
				<td>结余</td><td>{{(parseFloat(moneydiangong.shifa)+parseFloat(moneydaiban.shifa)+parseFloat(moneybanzu.jieyu)).toFixed(2) }}</td><td>{{moneydiangong.shifa.toFixed(2)}}</td><td>{{moneydaiban.shifa.toFixed(2)}}</td><td>{{moneybanzu.jieyu.toFixed(2)}}</td><td></td>
			</tr>
			<tr>
				<td>天数</td><td>{{(parseFloat(moneydiangong.workday)+parseFloat(moneydaiban.workday)+parseFloat(moneybanzu.workday)).toFixed(2) }}</td><td>{{moneydiangong.workday.toFixed(2)}}</td><td>{{moneydaiban.workday.toFixed(2)}}</td><td>{{moneybanzu.workday.toFixed(2)}}</td><td></td>
			</tr>
		</table>
		<h3 style="text-align:left;margin-top:30px">材料费用</h3>
		<table  border="1px" style="width:450px;height:80px">
			<tr>
				<th>总金额</th><th>未拨款</th><th>已拨款</th>
			</tr>
			<tr>
				<td>{{cailiaoinfo.pricesum}}元</td><td>{{cailiaoinfo.pricesum0}}元</td><td>{{cailiaoinfo.pricesum1}}元</td>
			</tr>
		</table>
		<h3 style="text-align:left;margin-top:30px">报销费用</h3>
		<table  border="1px" style="width:450px;height:80px">
			<tr>
				<th>总金额</th><th>未拨款</th><th>已拨款</th>
			</tr>
			<tr>
				<td>{{baoxiaoinfo.pricesum}}元</td><td>{{baoxiaoinfo.pricesum0}}元</td><td>{{baoxiaoinfo.pricesum1}}元</td>
			</tr>
		</table>
	</div>
</template>
<script>
import Kanban from './index.js'
export default Kanban
</script>

